import fetch from "auth/FetchInterceptor";

export const TaxService = {};

TaxService.get = async ({ page, pageSize, sort, searchText, state = null }) => {
  let apiUrl = "/v1/setting/tax?page=" + page + "&per_page=" + pageSize;
  if (sort === "ascend") apiUrl += "&order_by=%2Did";
  else if (sort === "descend") apiUrl += "&order_by=%2Bid";
  if (searchText) apiUrl += "&name=" + searchText;
  if (state) {
    apiUrl += "&state=" + state;
  }
  return fetch({
    url: apiUrl,
    method: "get",
  });
};

TaxService.getById = async (id) => {
  const apiUrl = `/v1/setting/tax/${id}`;
  return fetch({
    url: apiUrl,
    method: "get",
  });
};

TaxService.createTax = async (data) => {
  const apiUrl = `/v1/setting/tax`;
  return fetch({
    url: apiUrl,
    method: "post",
    data: data,
  });
};

TaxService.updateTax = async (data) => {
  const apiUrl = `/v1/setting/tax/${data.id}`;
  return fetch({
    url: apiUrl,
    method: "put",
    data: data,
  });
};

TaxService.deleteTax = async (id) => {
  const apiUrl = `/v1/setting/tax/${id}`;
  return fetch({
    url: apiUrl,
    method: "delete",
  });
};

export default TaxService;
